import { type CsticId } from "~/features/configurator/Linear/models";
import { type SubstepType } from "~/features/configurator/Linear/dtos";
import { type RootState } from "~/app/store";
import { getCsticMapFromNested } from "~/features/configurator/Linear/redux/selectors";
import { getDirtyParamName } from "~/features/configurator/Linear/namingUtils";
import type { LinearConfiguratorState } from "~/features/configurator/Linear/redux/types";

export const selectCsticExpanded = (csticId: CsticId, substep: SubstepType) => (state: RootState) =>
  selectCsticExpandedFromNested(csticId, substep)(state.linearConfigurator);

export const selectCsticExpandedFromNested =
  (csticId: CsticId, substep: SubstepType) => (state: LinearConfiguratorState) => {
    const cstic = selectCsticFromNested(csticId)(state);

    const stepDef = state.substeps[substep];
    const isInConflict = state.conflicts.some((conflict) =>
      conflict.cstics.find((cstic) => cstic.name === csticId.key),
    );
    const isDirty: boolean = stepDef.additionalData[getDirtyParamName(csticId)] ?? false;

    return {
      cstic,
      isInConflict,
      isDirty,
    };
  };

export const selectCstic = (csticId: CsticId) => (state: RootState) =>
  selectCsticFromNested(csticId)(state.linearConfigurator);

export const selectCsticFromNested = (csticId: CsticId) => (state: LinearConfiguratorState) => {
  const csticMap = getCsticMapFromNested(csticId.type, csticId.index)(state);
  return csticMap[csticId.key];
};
